import React from 'react';
import { useTranslation } from 'react-i18next';

// Country flag emojis
const countryFlags = {
  AU: '🇦🇺',
  US: '🇺🇸',
  EU: '🇪🇺',
  UK: '🇬🇧',
  NZ: '🇳🇿',
  CA: '🇨🇦',
  SG: '🇸🇬',
  JP: '🇯🇵',
  CN: '🇨🇳',
  KR: '🇰🇷',
  IN: '🇮🇳',
  BR: '🇧🇷',
  MX: '🇲🇽'
};

/**
 * Jurisdiction Row Component
 * Single row in the filing table showing jurisdiction status
 */
function JurisdictionRow({ filing, onFileNow, onView, onEditRef }) {
  const { t } = useTranslation('attorney');

  const getStatusDisplay = () => {
    switch (filing.status) {
      case 'pending':
        return { icon: '⏳', text: t('attorney.jurisdiction.pending', 'Pending'), className: 'status-pending' };
      case 'filed':
        return { icon: '✅', text: t('attorney.jurisdiction.filed', 'Filed'), className: 'status-filed' };
      case 'accepted':
        return { icon: '✓', text: t('attorney.jurisdiction.accepted', 'Accepted'), className: 'status-accepted' };
      case 'registered':
        return { icon: '🏆', text: t('attorney.jurisdiction.registered', 'Registered'), className: 'status-registered' };
      case 'rejected':
        return { icon: '❌', text: t('attorney.jurisdiction.rejected', 'Rejected'), className: 'status-rejected' };
      default:
        return { icon: '❓', text: filing.status, className: 'status-unknown' };
    }
  };

  const status = getStatusDisplay();
  const flag = countryFlags[filing.jurisdiction] || '🌐';

  return (
    <tr className="jurisdiction-row">
      <td className="jurisdiction-country">
        <span className="country-flag">{flag}</span>
        <span className="country-code">{filing.jurisdiction}</span>
      </td>
      <td className={`jurisdiction-status ${status.className}`}>
        <span className="status-icon">{status.icon}</span>
        <span className="status-text">{status.text}</span>
      </td>
      <td className="jurisdiction-ref">
        {filing.ipOfficeRef || '—'}
      </td>
      <td className="jurisdiction-actions">
        {filing.status === 'pending' ? (
          <button className="btn-file-now" onClick={onFileNow}>
            {t('attorney.jurisdiction.fileNow', 'File Now')}
          </button>
        ) : (
          <>
            <button className="btn-view" onClick={onView}>
              {t('attorney.jurisdiction.view', 'View')}
            </button>
            <button className="btn-edit-ref" onClick={onEditRef}>
              {t('attorney.jurisdiction.editRef', 'Edit Ref')}
            </button>
          </>
        )}
      </td>
    </tr>
  );
}

export default JurisdictionRow;
